import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { lowerCase } from 'lodash';
import { renderCreatableSelect } from '../../common/form/FieldHelper';
import {
  showXeroTaxModal,
  setDataXeroTaxModal,
} from '../integrations/integration_tabs/xero/modal/CreateXeroTaxModalActions';

const defaultTextField = (data) => {
  if (data.name) {
    return data.name;
  }

  return data.label;
};

const formatCreateLabel = (defaultAccount) => {
  return (value) => {
    return `Create in Xero... ${value}`;
  };
};

class XeroTaxRateDropdown extends Component {
  constructor(props) {
    super(props);

    this.onCreateOption = this.onCreateOption.bind(this);
  }

  onCreateOption() {
    const { showCreateModal, setDataModal, integrationId } = this.props;
    showCreateModal();
    setDataModal({ integrationId });
  }

  getValue() {
    const { listOptions, input, defaultName } = this.props;
    const { value } = input;

    if (value) {
      const valueOption = value
        ? listOptions.find((option) => option.taxType === value.taxType)
        : null;
      return valueOption;
    }

    const defaultValue = defaultName
      ? listOptions.find((l) =>
          lowerCase(l.name).includes(lowerCase(defaultName)),
        )
      : null;

    const defaultValueOption = defaultValue
      ? listOptions.find(
          (option) => lowerCase(option.name) === lowerCase(defaultValue.name),
        )
      : null;
    if (defaultValueOption) {
      input.onChange(defaultValueOption);
      return defaultValueOption;
    }

    return null;
  }

  render() {
    const {
      name,
      form,
      displayType,
      textField = defaultTextField,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          createOptionPosition="first"
          isCreatable={true}
          formId={form}
          component={renderCreatableSelect}
          name={name}
          formatCreateLabel={formatCreateLabel()}
          getOptionLabel={defaultTextField}
          getValue={this.getValue}
          displayType={displayType}
          textField={textField}
          onCreateOption={this.onCreateOption}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showCreateModal: showXeroTaxModal,
      setDataModal: setDataXeroTaxModal,
    },
    dispatch,
  );
}

function mapStateToProps(state, ownProps) {
  return {
    listOptions: ownProps.taxRates,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(XeroTaxRateDropdown);
